import Address from '../../../../models/Address';
var angular = require('angular');
var AddressService = /** @class */ (function () {
    function AddressService($http, $log, CreditCardService, Auth, Util, unleashFeatureService) {
        'ngInject';
        var _this = this;
        this.shippingCountries = ['US', 'PR', 'GU', 'VI']; //provide the values in UpperCase
        this.allowInternationalOrders = false;
        this.$log = $log;
        this.$http = $http;
        this.ccs = CreditCardService;
        this.Auth = Auth;
        this.Util = Util;
        this.unleashFeatureService = unleashFeatureService;
        // Object to store our user properties
        this.current = null;
        this.unleashFeatureService
            .isEnabledObserveViaName('allow-international-orders')
            .subscribe(function (isEnabled) {
            _this.allowInternationalOrders = isEnabled;
        });
    }
    AddressService.prototype.getAddresses = function (url, pageNumber, pageSize, searchTerm) {
        url = url || 'api/account/address/addresses';
        var params = {};
        if (pageNumber)
            params.pageNumber = pageNumber;
        if (pageSize)
            params.pageSize = pageSize;
        if (searchTerm)
            params.searchTerm = searchTerm;
        var request = this.$http({
            method: 'get',
            url: url,
            params: params
        });
        return (request.then(function (response) {
            if (response && response.data && response.data.response && response.data.response.currentPage) {
                var newPage_1 = [];
                response.data.response.currentPage.forEach(function (address, index) { return newPage_1[index] = new Address(address); });
                response.data.response.currentPage = newPage_1;
            }
            return response;
        }, function (response) { return response; }));
    };
    AddressService.prototype.getBusinessAddresses = function (pageNumber, pageSize, searchTerm) {
        return this.getAddresses(null, pageNumber, pageSize, searchTerm);
    };
    AddressService.prototype.getDropShipAddresses = function (pageNumber, pageSize, searchTerm) {
        return this.getAddresses('api/account/address/dropship', pageNumber, pageSize, searchTerm);
    };
    AddressService.prototype.deleteAddress = function (addressId) {
        return this.Util.handleApiResponse(this.$http.delete('api/account/address/' + addressId), this);
    };
    AddressService.prototype.setDefaultAddress = function (addressKey) {
        this.Auth.clearAccountCache();
        return this.Util.handleApiResponse(this.$http.put('api/account/address/default/' + addressKey), this);
    };
    AddressService.prototype.getRegions = function () {
        var request = this.$http({
            method: 'GET',
            url: 'api/admin/regions',
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    AddressService.prototype.getRegionsForCountry = function (countryCode) {
        var request = this.$http({
            method: 'GET',
            url: "api/admin/regions/" + countryCode,
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    AddressService.prototype.getCountries = function () {
        var request = this.$http.get('api/admin/countries');
        return (request.then(this.handleSuccess, this.handleError));
    };
    AddressService.prototype.isValidShippingCountries = function (countryCode) {
        if (this.allowInternationalOrders === true) {
            return true;
        }
        var countryCodeUpperCase = (countryCode || '').toUpperCase();
        var countryCodeInList = this.shippingCountries.indexOf(countryCodeUpperCase) >= 0;
        return countryCodeInList;
    };
    AddressService.prototype.getShippingCountries = function () {
        var _this = this;
        var request = this.$http.get('api/admin/countries');
        return (request.then(function (response) {
            if (_this.allowInternationalOrders !== true && response && response.data && response.data.response && response.data.response.currentPage) {
                var newPage = [];
                newPage = response.data.response.currentPage.filter(function (countries) {
                    return ((countries.countryCode || '').toUpperCase() == 'US');
                });
                response.data.response.currentPage = newPage;
            }
            return response;
        }, function (response) { return response; }));
    };
    AddressService.prototype.updateCreditCardAddress = function (creditCard, address) {
        creditCard.billingAddress = address;
        this.$log.debug('updated credit card with updated address...', creditCard);
        return this.ccs.updateCreditCard(creditCard);
    };
    AddressService.prototype.updateAddress = function (address) {
        if (typeof address.addressKey == 'undefined')
            return;
        return this.$http.put('api/account/address/' + address.addressKey, address);
    };
    return AddressService;
}());
export default AddressService;
//# sourceMappingURL=address.service.js.map